import {IForm} from '../pages/oneAddQuote/oneQuoteTypes'
import {getYearFromEffectiveDate} from '.'
import {METAL_LEVELS} from './catalogs'
export {
  BACKEND_URL,
  FEATURE_SHOW_GOOGLE_INTEGRATION,
  GOOGLE_CLIENT_ID,
  RING_CENTRAL_APP_SERVER,
  RING_CENTRAL_CLIENT_ID,
  VERSION_APP,
} from './appConfig'
export {
  INIT_FORM,
  INIT_FORM_ATTACHMENTS,
  INIT_FORM_EXTRAS,
  INIT_FORM_MEMBERS,
  INIT_FORM_QUOTE_POLICY,
  INIT_FORMS_PAYMENTS,
} from './policyFormDefaults'
export {
  COUNTRIES,
  DEDUCTION_TYPE_OPTIONS,
  DOCUMENT_STATUS_OPTIONS,
  GENDER_OPTIONS,
  IMMIGRATION_STATUS_CHOICES,
  MARITAL_STATUS,
  METAL_LEVELS,
  MONTHS,
  PAYMENT_STATUS_OPTIONS,
  RELATIONSHIP_OPTIONS,
  STATUS_POLICY,
  TABS_ONE_USER,
  TEMPLATES,
} from './catalogs'

export const STORAGE_NAMES = {
  TOKEN: 'TOKEN',
  USER: 'USER',
  PERMISSIONS: 'PERMISSIONS',
  ID_USER: 'USER_ID',
  LAST_ROUTE: 'LAST_ROUTE',
  KANBAN_SELECTED_GROUP: 'KANBAN_SELECTED_GROUP',
  KANBAN_SELECTED_WORKFLOW: 'KANBAN_SELECTED_WORKFLOW',
  KANBAN_SHARED_VIEW: 'KANBAN_SHARED_VIEW',
  TOKEN_GOOGLE: 'google_token',
  EMAIL_GOOGLE: 'google_email',
  RING_CENTRAL: 'ringcentral',
  VICIDIAL_SESSION: 'vicidial_session',
  VICIDIAL_FORCE_DISCONNECTED: 'vicidial_force_disconnected',
} as const

export const EVENT_SERVICE_WORKER_NAME = 'swUpdated' as const
export const MSG_SKIP_WAITING = 'SKIP_WAITING' as const


export const COLORS = ['primary', 'success', 'warning', 'danger', 'info', 'dark'] as const

export const bootstrapColorMap: Record<string, string> = {
  primary: '#0d6efd',
  secondary: '#6c757d',
  success: '#198754',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#0dcaf0',
  light: '#f8f9fa',
  dark: '#212529',
  gray: '#adb5bd',

  // Aliases usados en statuses
  blue: '#3e97ff',
  green: '#198754',
  red: '#dc3545',
  orange: '#fd7e14',
  purple: '#6f42c1',
  yellow: '#ffc107',
  accent: '#3e97ff',
}

// Devuelve un hex si es bootstrap, o un color si es válido, o gris como fallback
export function getBootstrapColorHex(color: string): string {
  if (bootstrapColorMap[color]) {
    return bootstrapColorMap[color]
  }

  // Si es un valor válido en CSS (ej: 'green' o '#123456'), lo devolvemos tal cual
  const isCssColor = CSS.supports('color', color)
  return isCssColor ? color : '#adb5bd'
}

export function getContrastTextColor(bgColor: string): string {
  // Convierte el hex a RGB
  const hex = bgColor.replace('#', '')
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)

  // Calcula luminancia relativa (receta WCAG)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Si es muy claro → texto negro, si es oscuro → texto blanco
  return luminance > 0.6 ? '#000000' : '#ffffff'
}

export const getPolicyCategory = (
  edges: {node: {code: string; category: string}}[] | undefined,
  code?: string
) => edges?.find((e) => e.node.code === (code ?? ''))?.node.category ?? null

export const ALL_PERMISSIONS = {
  VIEW_USER: 'view_user',
  ADD_USER: 'add_user',
  EDIT_USER: 'change_user',

  VIEW_LEAD: 'view_lead',
  ADD_LEAD: 'add_lead',
  DELETE_LEAD: 'delete_lead',
  EDIT_LEAD: 'change_lead',
  EXPORT_LEAD: 'export_lead',

  VIEW_POLICY: 'view_policy',
  VIEW_ALL_POLICIES: 'view_all_policies',
  VIEW_POLICY_MEMBER_ID_CARD: 'view_policy_member_id_card',
  ADD_POLICY: 'add_policy',
  EDIT_POLICY: 'change_policy',
  VIEW_POLICY_STATUS: 'view_policy_status',
  EXPORT_POLICY: 'export_policy',
  EXPORT_POLICY_FULL: 'export_policy_full',
  MARK_COMPLETED_POLICY: 'mark_completed_policy',
  REASSIGN_POLICY: 'reassign_policy',
  VIEW_POLICY_PAYMENT: 'view_policy_payment',

  VIEW_SETTING: 'view_setting',

  VIEW_PIPELINE: 'view_pipeline',
  VIEW_LEAD_SOURCE: 'view_lead_source',
  VIEW_GROUP_ASSIGNMENT: 'view_group_assignment',
  VIEW_LEAD_LOSS_REASON: 'view_lead_loss_reason',
  VIEW_TAG_MANAGER: 'view_tag_manager',


  VIEW_COMMISSION: 'view_commission_report',
  VIEW_ALL_COMMISSION: 'view_all_commission_report',
  VIEW_COMMISSION_FINDER: 'view_commission_finder',
  ADD_COMMISSION: 'add_commission_report',
  EDIT_COMMISSION: 'change_commission_report',
  DELETE_COMMISSION: 'delete_commission_report',

  VIEW_SIGNATURE_FORMS: 'view_signatureform',
  ADD_SIGNATURE_FORMS: 'add_signatureform',
  EDIT_SIGNATURE_FORMS: 'change_signatureform',
  DELETE_SIGNATURE_FORMS: 'delete_signatureform',

  VIEW_CONTACT: 'view_contact',
  ADD_CONTACT: 'add_contact',
  EDIT_CONTACT: 'change_contact',
  DELETE_CONTACT: 'delete_contact',
  VIEW_CONTACT_PREVIEW_ASSIGNED: 'view_contact_preview_assigned',
  VIEW_COMMUNICATION_LOGS: 'view_policy',
  

  VIEW_SMS: 'view_policy',
  VIEW_EMAIL: 'view_policy',

  VIEW_NOTIFICATION: 'view_notification',

  VIEW_INTEGRATION: 'view_integrations',
  ADD_INTEGRATION: 'add_integrations',
  EDIT_INTEGRATION: 'change_integrations',
  DELETE_INTEGRATION: 'delete_integrations',

  VIEW_CARRIER: 'view_insurance_operator',
  VIEW_CARRIER_IMPORT_BATCH: 'view_carrierimportbatch',
  ADD_CARRIER: 'add_insurance_operator',
  EDIT_CARRIER: 'change_insurance_operator',
  DELETE_CARRIER: 'delete_insurance_operator',

  VIEW_POLICY_TYPE: 'view_policy_type',
  ADD_POLICY_TYPE: 'add_policy_type',
  EDIT_POLICY_TYPE: 'change_policy_type',
  DELETE_POLICY_TYPE: 'delete_policy_type',

  VIEW_COMMISSION_DEDUCTION_TYPE: 'view_commission_deduction_type',
  ADD_COMMISSION_DEDUCTION_TYPE: 'add_commission_deduction_type',
  EDIT_COMMISSION_DEDUCTION_TYPE: 'change_commission_deduction_type',
  DELETE_COMMISSION_DEDUCTION_TYPE: 'delete_commission_deduction_type',

  VIEW_RESOURCE_CENTER: 'view_resource_center',
  ADD_RESOURCE_CENTER: 'add_resource_center',
  EDIT_RESOURCE_CENTER: 'change_resource_center',
  DELETE_RESOURCE_CENTER: 'delete_resource_center',

  VIEW_TASKS: 'view_kanbantask',
  ADD_TASKS: 'add_kanbantask',
  EDIT_TASKS: 'change_kanbantask',
  DELETE_TASKS: 'delete_kanbantask',

  VIEW_TICKET: 'view_ticket',
  ADD_TICKET: 'add_ticket',
  CHANGE_TICKET: 'change_ticket',
  DELETE_TICKET: 'delete_ticket',
  ASSIGN_TICKET: 'assign_ticket',
  CHANGE_TICKET_STATUS: 'change_ticket_status',
  COMMENT_TICKET: 'comment_ticket',
  DOWNLOAD_TICKET_ATTACHMENT: 'download_ticket_attachment',
  VIEW_ALL_TICKET: 'view_all_ticket',
  ARCHIVE_TICKET: 'archive_ticket',
  MANAGE_TICKET_SLA: 'manage_ticket_sla',

  VIEW_CAMPAIGNS: 'view_campaign',

} as const

export const INIT_PEOPLE = {
  age: '',
  dob: '',
  gender: 'Male',
  isPregnant: false,
  pregnantWith: '',
  isParent: false,
  usesTobacco: false,
  lastTobaccoUseDate: '',
  hasMec: false,
  aptcEligible: true,
  utilizationLevel: '',
  relationship: '',
  doesNotCohabitate: '',
  currentEnrollment: null,
}

export const SIZE_PAGE_QUICK_QUOTE = 20
export const SIZE_PAGE_DEFAULT = 10
export const SIZE_STEP_PAGINATION = 10


export function getPolicyName(values) {
  const first = values.firstName.trim()
  const middle = values.middleName.trim()
  const last = values.lastName.trim()
  const second = values.secondLastName.trim()

  // Toma la inicial en mayúscula si existe, si no, omite
  const middleInitial = middle ? ' ' + middle : ''
  const secondInitial = second ? ' ' + second : ''
  // const middleInitial = middle ? ` ${middle[0].toUpperCase()}.` : ''
  // const secondInitial = second ? ` ${second[0].toUpperCase()}.` : ''

  // Une los componentes
  return `${first}${middleInitial} ${last}${secondInitial}`.replace(/\s+/g, ' ').trim()
}

export function getMetalLevelValueByLabel(label: string): string | undefined {
  const found = METAL_LEVELS.find((level) => level.label === label)
  return found?.value
}

export function getMetalLevelValue(value: string): string | undefined {
  const found = METAL_LEVELS.find((level) => level.value === value)
  return found?.label
}

export const normalizeAmount = (val: any): string => {
  if (typeof val === 'string') {
    return val.replace(/,/g, '') || '0.00'
  }
  return typeof val === 'number' ? val.toFixed(2) : '0.00'
}


// Bootstrap variant type helper
export type BootstrapVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark'

// Map Document status → Bootstrap variant
export const getDocumentVariant = (value?: string): BootstrapVariant => {
  const v = (value || '').toString().toUpperCase()
  switch (v) {
    case 'COMPLETED':
      return 'success' // green
    case 'DECLINED':
      return 'danger' // red
    case 'PROCESSING':
    case 'PENDING':
      return 'warning' // amber
    case 'ACTIVE':
      return 'info' // blue/cyan
    default:
      return 'secondary' // neutral gray
  }
}

// Map Payment status → Bootstrap variant
export const getPaymentVariant = (value?: string): BootstrapVariant => {
  const v = (value || '').toString().toUpperCase()
  switch (v) {
    case 'PAID':
      return 'success' // green
    case 'FAILED':
      return 'danger' // red
    case 'PENDING':
      return 'warning' // amber
    case 'AUTO_PAY':
      return 'success'
    case 'NOT_APPLICABLE':
      return 'secondary' // neutral gray
    case 'PAGA_POR_SU_CUENTA':
      return 'warning' // amber
    default:
      return 'secondary'
  }
}

export const INIT_CONTACT_INFO = {
  fullName: '',
  firstName: '',
  middleName: '',
  lastName: '',
  secondLastName: '',
  preferredLenguage: '',
  dateBirth: null, // si usas Date, podría ser new Date() o null
  gender: '',
  email: '',
  phone: '',
  address1: '',
  address2: '',
  city: '',
  stateEUId: '', // ID puede ser string si viene de un select
  zipCode: '',
  countyFips: '',
  immigrationStatus: '',
  annualIncome1: 0,
  annualIncome2: 0,
  annualIncome3: 0,
  isImportant: false,
}

export const INITIAL_CONTACT_FILTERS: {
  name: string
  createdAfter: string
  createdBefore: string
  effectiveDateAfter: string
  effectiveDateBefore: string
  isImportant: undefined
  isArchived: undefined
  isPolicyHolder: undefined
  withoutPolicy: undefined
  withoutLead: undefined
  medicareUnifiedFilter: string
  carrier: string
  policyType: string
  user: string
  assignedTo: string
  zipCode: string
  state: string
  status: string
  policyStatus: string
  myContacts: undefined
  signatureForm: string
  signatureStatus: string
  preferredLanguage: string
  birthMonth: string
  ageFrom: string
  ageTo: string
  gender: string
  immigrationStatus: string | string[]
  policyCreatedFrom: string
  policyCreatedTo: string
  submissionDateFrom: string
  submissionDateTo: string
  completedDateFrom: string
  completedDateTo: string
  organizationId?: string
} = {
  name: '',
  createdAfter: '',
  createdBefore: '',
  effectiveDateAfter: '',
  effectiveDateBefore: '',
  isImportant: undefined,
  isArchived: undefined,
  isPolicyHolder: undefined,
  withoutPolicy: undefined,
  withoutLead: undefined,
  medicareUnifiedFilter: 'ALL_ELIGIBLE',
  carrier: '',
  policyType: '',
  user: '',
  assignedTo: '',
  zipCode: '',
  state: '',
  status: '',
  policyStatus: '',
  myContacts: undefined,
  signatureForm: '',
  signatureStatus: '',
  preferredLanguage: '',
  birthMonth: '',
  ageFrom: '',
  ageTo: '',
  gender: '',
  immigrationStatus: '',
  policyCreatedFrom: '',
  policyCreatedTo: '',
  submissionDateFrom: '',
  submissionDateTo: '',
  completedDateFrom: '',
  completedDateTo: '',
  organizationId: '',
}

export const INITIAL_POLICY_FILTERS: {
  policyName: string
  isImportant: undefined
  isArchived: undefined
  isPolicyHolder: undefined
  hasReminders: undefined
  hasMemberId: undefined
  commissionPayable: undefined
  advisorPaid: undefined
  unassigned: undefined
  ownsCar: undefined
  ownsHome: undefined
  hasAutoPolicy: undefined
  hasHomePolicy: undefined
  carrier: string
  insuranceCategory: string
  policyType: string
  user: string
  assignedTo: string
  zipCode: string
  state: string
  stateEU: string
  stateJurisdictionType: string
  status: string
  documentStatus: string
  paymentStatus: string
  leadSource: string
  signatureForm: string | string[]
  signatureStatus: string
  agentOfRecord: string[]
  immigrationStatus: string
  holderGender: string
  metalLevel: string
  createdAfter: string
  createdBefore: string
  effectiveDateAfter: string
  effectiveDateBefore: string
  documentsDueDateAfter: string
  documentsDueDateBefore: string
  paymentStatusDateAfter: string
  paymentStatusDateBefore: string
  advisorPaidDateAfter: string
  advisorPaidDateBefore: string
  advisorChargeback: undefined
  advisorChargebackDateAfter: string
  advisorChargebackDateBefore: string
  canceledAfter: string
  canceledBefore: string
  completedAfter: string
  completedBefore: string
  effectiveYear: string
  carrierStatusGeneric: string
  carrierStatusRaw: string
  carrierLastAsOfDateAfter: string
  carrierLastAsOfDateBefore: string
  carrierIsAgeIn: undefined
  carrierIsDelinquent: undefined
  carrierIsUnpaidPending: undefined
  carrierIsUnpaidPastDue: undefined
} = {
  policyName: '',
  isImportant: undefined,
  isArchived: undefined,
  isPolicyHolder: undefined,
  hasReminders: undefined,
  hasMemberId: undefined,
  commissionPayable: undefined,
  advisorPaid: undefined,
  unassigned: undefined,
  ownsCar: undefined,
  ownsHome: undefined,
  hasAutoPolicy: undefined,
  hasHomePolicy: undefined,
  carrier: '',
  insuranceCategory: '',
  policyType: '',
  user: '',
  assignedTo: '',
  zipCode: '',
  state: '',
  stateEU: '',
  stateJurisdictionType: '',
  status: '',
  documentStatus: '',
  paymentStatus: '',
  leadSource: '',
  signatureForm: [],
  signatureStatus: '',
  agentOfRecord: [],
  immigrationStatus: '',
  holderGender: '',
  metalLevel: '',
  createdAfter: '',
  createdBefore: '',
  effectiveDateAfter: '',
  effectiveDateBefore: '',
  documentsDueDateAfter: '',
  documentsDueDateBefore: '',
  paymentStatusDateAfter: '',
  paymentStatusDateBefore: '',
  advisorPaidDateAfter: '',
  advisorPaidDateBefore: '',
  advisorChargeback: undefined,
  advisorChargebackDateAfter: '',
  advisorChargebackDateBefore: '',
  canceledAfter: '',
  canceledBefore: '',
  completedAfter: '',
  completedBefore: '',
  effectiveYear: '',
  carrierStatusGeneric: '',
  carrierStatusRaw: '',
  carrierLastAsOfDateAfter: '',
  carrierLastAsOfDateBefore: '',
  carrierIsAgeIn: undefined,
  carrierIsDelinquent: undefined,
  carrierIsUnpaidPending: undefined,
  carrierIsUnpaidPastDue: undefined,
}

/*
export const INITIAL_POLICY_FILTERS_2: {
  policyName: '',
  carrier: '',
  createdAt: '',
  effectiveDate: '',
  completed: '',
  canceled: '',
  archived: '',
  isImportant: false,
  isArchived: false,
  isReminders: false,
  policyType: '',
  user: '',
  agent: '',
  status: '',
  stateEU: '',
  assignedTo: '',
  zipCode: '',
  effectiveYear: '',
  insuranceCategory: '',
}*/

const DEFAULT_EFFECTIVE_DATE = new Date().toISOString().slice(0, 10)

export const INIT_IFORM: IForm = {
  queryType: 'individual',
  effectiveDate: DEFAULT_EFFECTIVE_DATE,
  year: getYearFromEffectiveDate(DEFAULT_EFFECTIVE_DATE),
  householdIncome: '0',
  market: 'FFM',
  countyfips: '',
  countyfipsName: '',
  state: 'FL',
  zipCode: '',
  limit: 10,
  offset: 0,
  order: 'asc',
  utilizationLevel: '',
  numberOfMembers: '1',
  personOne: {
    age: '',
    dob: '',
    gender: '',
    isPregnant: false,
    pregnantWith: '',
    isParent: false,
    usesTobacco: false,
    lastTobaccoUseDate: '',
    hasMec: true,
    aptcEligible: true,
    utilizationLevel: '',
    relationship: 'self',
    doesNotCohabitate: '',
    currentEnrollment: null,
  },
  people: [],
}
